/* ============================================================
   SKINTIFIC — shared behavior: nav, MENU overlay, theme, motion
   ============================================================ */
(function(){
  // ---- theme (written by the Tweaks panel on the homepage) ----
  function applyTheme(){
    let t={};
    try{ t=JSON.parse(localStorage.getItem('skintific-theme')||'{}'); }catch(e){}
    const r=document.documentElement;
    r.classList.toggle('theme-ivory', t.theme==='ivory');
    r.classList.remove('accent-rose','accent-none');
    if(t.accent==='rose') r.classList.add('accent-rose');
    if(t.accent==='none') r.classList.add('accent-none');
    const fonts={
      saira:'"Saira Condensed", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      cormorant:'"Cormorant Garamond", Garamond, "Times New Roman", serif',
      archivo:'"Archivo", -apple-system, BlinkMacSystemFont, sans-serif'
    };
    if(t.font && fonts[t.font]) r.style.setProperty('--display', fonts[t.font]);
    else r.style.removeProperty('--display');
    // motion
    if(t.motion){ r.classList.add('js-motion'); enableMotion(); }
    else { r.classList.remove('js-motion'); }
  }
  window.skintificApplyTheme=applyTheme;
  window.addEventListener('storage',e=>{ if(e.key==='skintific-theme') applyTheme(); });

  // ---- nav scrolled state ----
  function onScroll(){
    const nav=document.querySelector('.nav');
    if(nav) nav.classList.toggle('scrolled', window.scrollY>40);
  }
  window.addEventListener('scroll', onScroll, {passive:true});

  // ---- MENU overlay ----
  const LINKS=[
    {i:'01', t:'The Devices', h:'/#devices'},
    {i:'02', t:'The Ritual',  h:'/#ritual'},
    {i:'03', t:'The Wand',    h:'/products/advanced-led-therapy-light-3'},
    {i:'04', t:'The Science', h:'/pages/our-story'},
    {i:'05', t:'Skin Quiz',   h:'/pages/skin-quiz'},
    {i:'06', t:'Client Care', h:'/pages/help-center'}
  ];
  function buildMenu(){
    if(document.querySelector('.menu-overlay')) return;
    const ov=document.createElement('div');
    ov.className='menu-overlay';
    ov.innerHTML=`
      <div class="menu-bar">
        <button class="menu-close" data-menu-close><span style="font-size:15px;line-height:1;">×</span> Close</button>
        <div class="wordmark">Skintific</div>
        <div></div>
      </div>
      <div class="menu-body">
        <nav class="menu-links">
          ${LINKS.map(l=>`<a href="${l.h}"><span class="idx">${l.i}</span>${l.t}</a>`).join('')}
        </nav>
        <aside class="menu-side">
          <div class="menu-feature">
            <image-slot id="menu-feature" placeholder="DROP — device hero" fit="cover" src="https://www.skintificbeauty.com/cdn/shop/t/34/assets/skintific-wand-use.jpg?v=85465614670651917161778953965"></image-slot>
          </div>
          <div class="menu-meta">
            <h6>Featured — Device No. 001</h6>
            <p>The Rejuvenating Wand. 633nm clinical output, five-minute ritual, in the palm of your hand.</p>
          </div>
          <div class="menu-social">
            <span>Instagram</span><span>Newsletter</span><span>EN · USD</span>
          </div>
        </aside>
      </div>`;
    document.body.appendChild(ov);
    ov.addEventListener('click', e=>{ if(e.target.matches('[data-menu-close]')||e.target.closest('[data-menu-close]')) closeMenu(); });
    // Close the menu when any nav link is clicked so navigation feels responsive
    ov.querySelectorAll('.menu-links a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeMenu(); });
  }
  function openMenu(){ const ov=document.querySelector('.menu-overlay'); if(ov){ ov.classList.add('open'); document.body.classList.add('menu-open'); } }
  function closeMenu(){ const ov=document.querySelector('.menu-overlay'); if(ov){ ov.classList.remove('open'); document.body.classList.remove('menu-open'); } }
  window.skintificOpenMenu=openMenu;

  // ---- motion: reveal on scroll with fail-safe (env-safe) ----
  let motionWired=false;
  function enableMotion(){
    if(motionWired) return; motionWired=true;
    const check=()=>{
      const vh=window.innerHeight;
      document.querySelectorAll('.reveal:not(.in)').forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.top < vh*0.92 && r.bottom > 0) el.classList.add('in');
      });
    };
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check, {passive:true});
    check(); requestAnimationFrame(check);
    // fail-safe: never leave content stuck hidden (covers frozen-transition envs)
    setTimeout(()=>{
      document.querySelectorAll('.reveal:not(.in)').forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.top < window.innerHeight) el.classList.add('in');
      });
      // hard guarantee for anything still hidden above the fold
      setTimeout(()=>document.querySelectorAll('.reveal').forEach(el=>{
        if(getComputedStyle(el).opacity==='0'){ el.style.transition='none'; el.style.opacity='1'; el.style.transform='none'; }
      }), 700);
    }, 900);
  }

  function init(){
    applyTheme();
    onScroll();
    buildMenu();
    document.querySelectorAll('[data-menu-open]').forEach(b=>b.addEventListener('click', openMenu));
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
